module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAXCAYAAAB9J90oAAAAAXNSR0IArs4c6QAAAQBJREFUWEftlzEKwkAQRf8oSNTKWAnewcIqXa7hBfQGNhokBBtvYA6g10iXysI7iKkSKzUIOrIJiEKsMmCCmXKLP4+/s+wfgqrFpY97vALYBNBLzn5fAUAe6toUdutACeQj3oNZ/z1bBgFRhJo2IMyjDcCjQkK+oGhLmIfHAl33N78CBcrFdjOlq0Clb6lytHJU2gFpvWpG/9rRsnyhZQklpYl5pQnOEs/TitZgHmdKEblw9EneNpRXIF1luIHHyQOz8aFH5KPWMWHTLW8fGVBFsTz3cI13byE8QFMbYtYO8kKmeVSyrNBIFrKk2ITT9aXkZUEVlRWms+p0XSlIpfMEV5tmCJ5hCXQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/learnmodel/tips.png
// module id = ilWT
// module chunks = 96